import classes from './InformationPopup.module.css'

import x from '../../../images/x.png'
import arrowUp from '../../../images/arrowUp.png'

function InformationPopup({ message1, message2, btn, onConfirm, onCancel }) {
  return (
    <div className={`${classes.main_container} popup_basic bc_blue`}>
      <div className={classes.inner_container}>
        <img
          src={x}
          alt="x"
          onClick={() => {
            onCancel(null)
          }}
          className={`${classes.img} pointer`}
        />

        <div dir="rtl">
          <p className={classes.message1}>{message1}</p>
          <p className={classes.message2}>{message2}</p>
        </div>

        <p dir="rtl" className={classes.message}>
          {btn}
        </p>
        <img
          className={`${classes.arrowUp} pointer`}
          src={arrowUp}
          alt="<"
          onClick={() => {
            onCancel(null)
          }}
        />
      </div>
    </div>
  )
}

export default InformationPopup
